import {useCallback, useEffect, useState} from "react";
import {Navigate} from "react-router-dom";
import {API_ENDPOINTS} from "../../config";
import SingleBlogView from "./SingleBlogView";
import Button1 from "../../UI/Button1";
import fetch from "node-fetch";

const AllBlogsView = () => {

    const[allBlogs, SetAllBlogs] = useState([]);
    const[language, SetLanguage] = useState('en');
    const[isFetching, SetIsFetching] = useState(false);

    const [isLoading, SetLoading] = useState(false);


    const token = localStorage.getItem('token');

    const fetchAllBlogs = useCallback(async () => {

        if (!token) {
            console.log("No token found.");
            return;
        }

        SetLoading(true);

        console.log("Fetch all blogs for language => ", language);

        const url = `${API_ENDPOINTS.getAllBlogs}/${language}`;
        const options =  {
            method : 'GET',
            headers : {
                'Content-Type' : 'application/JSON',
                'Authorization' : `Bearer ${token}`
            }
        }

        console.log("Fetching all jobs...", url);

        try {
            const response = await fetch(url, options);

            if(response.ok){
                const blogData = await response.json();
                console.log("GotBlogData Back => " , blogData);
                 SetAllBlogs(blogData.items);
            } else {
                console.log("Response from Webflow Not OK");
            }
        } catch (e){
            console.log("Error fetching data from webflow.");
        } finally {
            SetLoading(false);
        }
    },[language, token]);


    useEffect(() => {
        fetchAllBlogs();
    }, [fetchAllBlogs])

    const changeLanguage = (e) => {
        console.log("Changing blog language to => " , e);
        SetLanguage(e);
    }

    const handleOpenSingleBlog = (e) => {
        console.log("HandleOpenBlog with e => " , e);
    }

    const handleDelete =  async (id) => {
        const token = localStorage.getItem('token');

        SetLoading(true);
        const url = `${API_ENDPOINTS.deleteBlog}/${id}/${language}`;

        console.log("Should delete blog with URL :> " , url);

        try {
            console.log("HandleDelete with url => " , url)
            const response = await fetch(url, {
                method:'DELETE',
                headers : {
                    'Content-Type' : 'application/json',
                    'Authorization': `Bearer ${token}`
                }
            });


            console.log("Response => " , response);

            if(response.ok){
                console.log('Delete OK , response => ', response);
                await fetchAllBlogs();
            } else {
                const errorData = await response.json();
                console.error('Delete failed', errorData);
            }
        } catch(e) {
            console.error('Error during delete request', e);
        } finally {
            SetLoading(false);
        }
    }

    return(
        <div>
            {isLoading ? (
                <p>Loading..</p>
            ) : (
                <>
                    <div className={'flex gap-3'}>
                        <Button1 onclick={() => changeLanguage('de')} text={"DE"}></Button1>
                        <Button1 onclick={() => changeLanguage('en')} text={"EN"}></Button1>
                    </div>
                    <div className={'flex flex-row mt-10 mb-5 gap-1'}>
                        <h2>Search:</h2>
                        <input/>
                    </div>
                    <div className={'grid grid-flow-col mt-10 mb-5 gap-1'}>
                        {allBlogs && allBlogs.map(x => (
                            <div className={'gap-1 m-2'} key={x.id}>
                                <SingleBlogView
                                    id={x.id}
                                    fieldData={x.fieldData}
                                    hiData={"Hi Data"}
                                    lang={language}
                                    handleDelete={handleDelete}
                                />
                            </div>
                        ))}
                    </div>
                </>
            )}
        </div>
    )
}

export default AllBlogsView;